import { createFileRoute, redirect } from '@tanstack/react-router';

// Outbound SSO 一覧は IdP 設定へ集約したため、旧 Software タブ URL は寄せる。
export const Route = createFileRoute('/_staff/software/_layout/sso/')({
  beforeLoad() {
    throw redirect({
      to: '/idp/settings/sso'
    });
  }
});